import React, { useState } from "react"

import Button from "@/components/core/Button/Button"

import { accordionUniqueId } from "@/utils/index"
import { handleZipDownload } from "@/utils/helper"

import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import Style from "@/components/MultiFinshProductBundle/styles/BundleDetailsAccordianUI.module.scss"

import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import Collapsible from "react-collapsible"
import CollapsibleHeader from "@/components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader"

import {
  accordianClickBundleFeature,
  addAnlyticsForSDownloadSpec,
} from "@/components/MultiFinshProductBundle/analytics"

const BundleSpecsInstallationUI = props => {
  const {
    label = "",
    specFiles = [],
    installGuidesFiles = [],
    isOpen = false,
    sku = "",
    productInfoBundle = {},
  } = props || {}

  const [isDisabledSpec, setIsDisabledSpec] = useState(false)
  const [isDisabledInstall, setIsDisabledInstall] = useState(false)

  const { t } = useTranslation("common")
  const {
    specsInstallationLabel = "",
    downloadAllSpecSheetsLabel = "",
    downloadAllInstallGuidesLabel = "",
  } = getTranslations(t)

  const handleDownloadSpecZip = async (
    downloadAllSpecSheetsLabel = "",
    mainTitle = ""
  ) => {
    try {
      const selectedFileList = []
      specFiles.forEach(selectedObj => {
        const techFileInfo = selectedObj.substring(
          selectedObj.lastIndexOf("/") + 1
        )
        selectedFileList.push(techFileInfo)
      })

      addAnlyticsForSDownloadSpec(
        downloadAllSpecSheetsLabel,
        selectedFileList,
        specFiles,
        mainTitle,
        productInfoBundle
      )
      await handleZipDownload(specFiles, sku)
      setIsDisabledSpec(false)
    } catch {
      setIsDisabledSpec(false)
    }
  }

  const handleDownloadInstallGuidesZip = async (
    downloadAllSpecSheetsLabel = "",
    mainTitle = ""
  ) => {
    setIsDisabledInstall(true)
    try {
      const selectedFileList = []
      installGuidesFiles.forEach(selectedObj => {
        const techFileInfo = selectedObj.substring(
          selectedObj.lastIndexOf("/") + 1
        )
        selectedFileList.push(techFileInfo)
      })

      addAnlyticsForSDownloadSpec(
        downloadAllSpecSheetsLabel,
        selectedFileList,
        installGuidesFiles,
        mainTitle,
        productInfoBundle
      )
      await handleZipDownload(installGuidesFiles, sku)
      setIsDisabledInstall(false)
    } catch {
      setIsDisabledInstall(false)
    }
  }

  const handleOpenAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "expand",
      productInfoBundle
    )
  }
  const handleCloseAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "collapse",
      productInfoBundle
    )
  }

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${Style.BundlesDetailsAccordianUI} container-fluid`}
    >
      <div
        className={`collapsible-accordion bundle-accordian-section ${label.toLowerCase()}`}
        data-testid={`bundle-product-accordion-${label}`}
      >
        <Collapsible
          trigger={<CollapsibleHeader title={label} />}
          triggerOpenedClassName="collapsible__trigger--open"
          onTriggerOpening={() => handleOpenAccordian(label)}
          onTriggerClosing={() => handleCloseAccordian(label)}
          open={false}
          openedClassName="collapsible--open"
          transitionTime={400}
          tabIndex="0"
          easing="ease-in-out"
          triggerElementProps={{
            id: accordionUniqueId("collapsible-trigger", 9999, 1000),
          }}
          contentElementId={accordionUniqueId(
            "collapsible-content",
            9999,
            1000
          )}
        >
          {(specFiles.length || installGuidesFiles.length) && (
            <div
              className="row no-gutters px-0"
              data-testid={`colapse-data-${specsInstallationLabel}`}
              aria-disabled={isOpen}
            >
              <div className="col-12 bundles-accordian-button">
                {specFiles.length ? (
                  <Button
                    type="ghost"
                    role="button"
                    label={downloadAllSpecSheetsLabel}
                    onClick={() =>
                      handleDownloadSpecZip(
                        downloadAllSpecSheetsLabel.toLowerCase(),
                        specsInstallationLabel.toLowerCase()
                      )
                    }
                    disabled={isDisabledSpec}
                    loading={isDisabledSpec}
                  />
                ) : null}
                {installGuidesFiles.length ? (
                  <Button
                    type="ghost"
                    role="button"
                    label={downloadAllInstallGuidesLabel}
                    onClick={() =>
                      handleDownloadInstallGuidesZip(
                        downloadAllInstallGuidesLabel.toLowerCase(),
                        specsInstallationLabel.toLowerCase()
                      )
                    }
                    disabled={isDisabledInstall}
                    loading={isDisabledInstall}
                  />
                ) : null}
              </div>
            </div>
          )}
        </Collapsible>
      </div>
    </div>
  )
}
export default BundleSpecsInstallationUI
